/**
 * Bármilyen stringből csinál PascalCase-t.
 * @example
 * to-pascal-case → ToPascalCase
 * @param {string} str - A string, amit átalakítunk.
 * @returns {string} Az átalakított szöveg.
 */
module.exports.toPascalCase = function toPascalCase (str) {
  const words = str.match(/[\da-z]+/gi)

  if (!words) {
    return ''
  }

  const pascal = words
    .map((word) => {
      const firstChar = word.charAt(0).toUpperCase()
      const rest      = word.slice(1).toLowerCase()
      const res       = firstChar + rest

      return res
    })
    .join('')

  return pascal
}
